import React, { useState } from 'react';
import { GenPage, SegmentControl } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const HeadlinesSlugs = () => {
  const t = useT();
  const [count, setCount] = useState('10');

  return (
    <GenPage
      title={t('page.headlinesSlugs.title')}
      contentType="headlinesSlugs"
      description={t('page.headlinesSlugs.desc')}
      outputLabel={t('page.headlinesSlugs.output')}
      extraOptions={
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-gray-500 font-medium whitespace-nowrap">{t('label.headlines')}</span>
          <SegmentControl
            options={['5', '10', '15', '20']}
            value={count}
            onChange={setCount}
          />
        </div>
      }
      extraInstructions={`Number of headlines to generate: ${count}`}
    />
  );
};
